import onDomReady from "./onDomReady";

onDomReady(() => {
	/** EVENTS */

	function list_page_header_max_height() {
		const width = window.innerWidth;
		if (width <= 580) return 60;
		if (width <= 1024) return 80;
		if (width <= 1560) return 100;
		return 130;
	}

	$(window).on('scroll resize', function () {
		list_page_header_scroll();
	});

	/** HEADER */
	let listPageHeader = $('.list-page-header'),
		listPageHeaderBgHelper = $('.list-page-header-bg-helper'),
		originalHeaderHeight;

	function list_page_header_scroll() {
		originalHeaderHeight = listPageHeaderBgHelper.outerHeight();

		let scrollTop = $(window).scrollTop(),
			nh = originalHeaderHeight - scrollTop,
			np,
			mh = list_page_header_max_height();

		if (nh < mh)
			nh = mh;

		const text = (originalHeaderHeight - nh) / (originalHeaderHeight - mh);
		let opacity = text;

		opacity = opacity * 1.75;

		if (opacity > 1)
			opacity = 1;

		np = 75 - (text * 25);

		if (np < 50)
			np = 50;

		listPageHeader.css({
			height: nh + 'px'
		});

		$('.list-page-header-title').css('top', np + '%');
		$('.list-page-header-image-blurred').css('opacity', opacity);
	}

	listPageHeader.css('padding-bottom', 0);
	list_page_header_scroll();
});
